import { cut } from "@/lib/api";

const lineRows = (e, sec, h, hideZero, labels) => {
  const rows = [{ key: `${sec}-h`, label: labels[sec], type: "section" }];
  let group = null;
  e.sections[sec].forEach((l, i) => {
    const vals = cut(l.values, h);
    if (hideZero && vals.every((v) => Math.abs(v) < 0.005)) return;
    if (l.group && l.group !== group) {
      group = l.group;
      rows.push({ key: `${sec}-g-${i}`, label: l.group, type: "group", indent: 1 });
    }
    const meta = [l.escalation != null ? `esc ${(l.escalation * 100).toFixed(1)}%` : null, l.source !== "formula" ? l.source : null]
      .filter(Boolean).join(" · ");
    rows.push({ key: `${sec}-${i}`, label: l.label, values: vals, indent: l.group ? 2 : 1, meta });
  });
  return rows;
};

export const buildEntityRows = (e, h, hideZero, labels) => {
  const s = (k) => cut(e.series[k], h);
  const total = (key, label, k) => ({ key, label, values: s(k), type: "subtotal" });
  return [
    ...lineRows(e, "income", h, hideZero, labels),
    total("inc-t", "Total income", "income"),
    ...lineRows(e, "expenses", h, hideZero, labels),
    total("exp-t", "Total expenses", "expenses"),
    { key: "ebitda", label: "Operating Surplus (EBITDA)", values: s("ebitda"), type: "total" },
    { key: "ebitda-m", label: "EBITDA margin", values: s("ebitda_margin"), type: "pct" },
    ...lineRows(e, "unit_capex", h, hideZero, labels),
    total("uc-t", "Total unit capex", "unit_capex"),
    total("sauc", "Surplus after unit capex", "surplus_after_unit_capex"),
    ...lineRows(e, "interest", h, hideZero, labels),
    total("sai", "Surplus after interest", "surplus_after_interest"),
    ...lineRows(e, "project_capex", h, hideZero, labels),
    total("pc-t", "Total project capex", "project_capex"),
    total("sapc", "Surplus after project capex", "surplus_after_project_capex"),
    { key: "ls-h", label: "Loan Summary", type: "section" },
    { key: "ls-o", label: "Opening", values: s("loan_opening"), indent: 1, noTotal: true },
    { key: "ls-d", label: "Drawdown", values: s("drawdown"), indent: 1 },
    { key: "ls-r", label: "Repayment", values: s("repayment"), indent: 1 },
    { key: "ls-c", label: "Closing", values: s("loan_closing"), indent: 1, noTotal: true, type: "subtotal" },
    { key: "ncf", label: "Net Cash Flow", values: s("ncf"), type: "total" },
  ];
};

export const loanRows = (l, h) => [
  { key: "o", label: "Opening", values: cut(l.opening, h), noTotal: true },
  { key: "d", label: "Drawdown", values: cut(l.drawdown, h) },
  { key: "r", label: "Repayment", values: cut(l.repayment, h) },
  { key: "c", label: "Closing", values: cut(l.closing, h), noTotal: true, type: "subtotal" },
  { key: "a", label: "Average balance", values: cut(l.avg_balance, h), noTotal: true },
  { key: "i", label: "Interest", values: cut(l.interest, h) },
];
